import { render, staticRenderFns } from "./recPrivilege.vue?vue&type=template&id=024ab15e&"
import script from "./recPrivilege.vue?vue&type=script&lang=js&"
export * from "./recPrivilege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports